import React, { PropsWithChildren, useEffect, useMemo } from 'react';
import styles from './PurchaseButton.module.scss';

/* Translations */
import { useTranslation } from 'react-i18next';
import { tr } from '../../../../../utils/translations/translator';

/* Providers */
import { useProductContext } from '../../../__providers__/ProductContext';
import { usePaymentTypeContext } from '../../../__providers__/PaymentTypeContext';
import { usePaymentProvider } from '../../../__providers__/PaymentProvider';
import { useLoadingContext } from '../../../__providers__/LoadingProvider';
import { useShopContext } from '../../../../Shops/shared/__providers__/ShopContext';
import { useStoreContext } from '../../../__providers__/StoreContext';

/* Components */
import { PayPalButtons } from '@paypal/react-paypal-js';

/* Toast */
import { toast } from 'react-toastify';

/* Interfaces */
import {
  PurchaseStatus,
  usePurchaseStatusProvider,
} from '../../../../Shops/shared/__providers__/PurchaseStatusProvider';
import { PixPaymentProcessor } from '../../../interfaces/PixPaymentProcessor';
import { PaymentTypesReversed } from '../../../interfaces/payment_types';
import { PaymentError } from '../../../interfaces/PaymentProcessor';
// import { usePromoCodeContext } from '../../../__providers__/PromoCodeProvider';

interface PurchaseButtonProps {}

export const PurchaseButton: React.FC<
  PurchaseButtonProps & PropsWithChildren
> = ({ children }) => {
  const { t } = useTranslation();
  const { selectedPayment } = usePaymentTypeContext();
  const { store } = useStoreContext();
  const { shop } = useShopContext();
  const { product } = useProductContext();
  const { loading } = useLoadingContext();
  const { purchaseStatus } = usePurchaseStatusProvider();
  const { paymentIntent, verifyPayment, processor, purchaseID } =
    usePaymentProvider();
  // const {
  //   states: { promoCodeID },
  // } = usePromoCodeContext();

  return (
    <div className={styles.container}>
      {product.unlockable ? (
        <button
          className={styles.unlockableBtn}
          onClick={() => paymentIntent()}
          disabled={loading}
        >
          {tr(t, 'unlock').toUpperCase()}
        </button>
      ) : (
        <>
          {selectedPayment === PaymentTypesReversed.Paypal && (
            <PayPalButtons
              style={{
                color: 'blue',
                layout: 'vertical',
                shape: 'pill',
                tagline: false,
                height: 55,
              }}
              // forceReRender={[promoCodeID]}
              fundingSource="paypal"
              createOrder={paymentIntent}
              onApprove={() => verifyPayment(shop)}
              onCancel={() => {
                toast.error(tr(t, 'transaction-cancelled'));
              }}
              onError={(e: any) =>
                processor!.handleError(e as unknown as PaymentError)
              }
            />
          )}

          {selectedPayment === PaymentTypesReversed.Pix && (
            <button
              disabled={loading}
              className={styles[selectedPayment]}
              onClick={() => {
                switch (purchaseStatus) {
                  case PurchaseStatus.NOT_STARTED:
                  case undefined:
                    return paymentIntent();
                  case PurchaseStatus.PENDING:
                    return (processor as PixPaymentProcessor).finishPayment(
                      store,
                      purchaseID,
                      shop!,
                    );
                }
              }}
            >
              {children}
            </button>
          )}

          {selectedPayment === PaymentTypesReversed.Stripe && (
            <button
              disabled={loading}
              className={styles[selectedPayment]}
              onClick={() => paymentIntent()}
            >
              {children}
            </button>
          )}
          {!selectedPayment && (
            <button disabled className={styles.unselected}>
              {children}
            </button>
          )}
        </>
      )}
    </div>
  );
};
